import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { CONS } from '@pomofocus/core';
import { globalActions, configActions, webPushActions, useAppDispatch, useAppSelector, userSelectors, todoListActions, configSelectors, } from '@pomofocus/shared-client';
import * as colors from '../../../colors';
import Modal from '../../common/Modal';
import * as sounds from '../../../sounds';
import { ENV, WEBPUSH_TYPE_BOTH } from '../../../constants';
import { ModalFooterStyle, ModalTitle, } from '../../styles/ModalStyles';
import { getCurrentPushSubscription, subscribeToPush, removeExistingSubscription, } from '../../../services/serviceWorkerService';
import { saveConfig } from '../../../modules/IndexedDB';
import { TimerConfig } from './TimerConfig';
import { TaskConfig } from './TaskConfig';
import { SoundConfig } from './SoundConfig';
import { ThemeConfig } from './ThemeConfig';
import { ReportConfig } from './ReportConfig';
import { NotificationConfig } from './NotificationConfig';
import { IntegrationConfig } from './IntegrationConfig';
import { Button } from '../../common/Button';
function ConfigModal() {
    const dispatch = useAppDispatch();
    // Redux selectors (from container)
    const userId = useAppSelector((state) => state.user.user._id);
    const authenticated = useAppSelector((state) => state.user.authenticated);
    const webpushSubs = useAppSelector((state) => state.config.webpushSubs);
    const isPremium = useAppSelector((state) => userSelectors.selectIsPremium(state));
    const todolistAppId = useAppSelector((state) => state.todoList.appId);
    // const vapIdPublicKey = useAppSelector(
    //   (state: RootState) => state.global.vapIdPublicKey,
    // );
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    const configModalVisible = useAppSelector((state) => state.config.configModalVisible);
    // Action dispatchers (from container)
    // const openConfigModal = () => {
    //   dispatch(
    //     configActions.changeConfigModalVisibility({ visible: true }),
    //   );
    // };
    const closeModal = () => {
        dispatch(configActions.changeConfigModalVisibility({ visible: false }));
    };
    const updateConfigObj = (_configObj) => {
        dispatch(configActions.updateConfigObj(_configObj));
    };
    const saveConfigToLocalDB = (_configObj) => {
        saveConfig(_configObj);
    };
    const saveConfigToMongoDB = (_configObj) => {
        dispatch(configActions.saveConfig({
            config: _configObj,
            onSaved: () => { },
        }));
    };
    const showUpgradeModal = () => {
        dispatch(globalActions.changeVisibleModal({
            visibleModal: CONS.MODAL_UPGRADE,
        }));
    };
    const showTodoistDocModal = () => {
        dispatch(globalActions.changeVisibleModal({
            visibleModal: CONS.MODAL_TODO_LIST_DOC,
        }));
    };
    const updateWebPushSub = (webpushSub) => {
        dispatch(webPushActions.updateWebPushSubscription({ webpushSub }));
    };
    const addWebPushSub = (subscription, alarmType) => {
        dispatch(webPushActions.saveWebPushSubscription({
            subscription,
            alarmType,
        }));
    };
    const testWebPush = () => {
        dispatch(webPushActions.testWebPush());
    };
    const removeWebPushSub = (auth) => {
        removeExistingSubscription();
        dispatch(webPushActions.removeWebPushSubscription({ auth }));
    };
    const showCrossDeviceAlarmDocModal = () => {
        dispatch(globalActions.changeVisibleModal({
            visibleModal: CONS.MODAL_CROSS_DEVICE_ALARM_DOC,
        }));
    };
    const openWebhookModal = () => {
        dispatch(globalActions.changeVisibleModal({
            visibleModal: CONS.MODAL_WEBHOOK_FORM,
        }));
    };
    const showWebhookDocModal = () => {
        dispatch(globalActions.changeVisibleModal({
            visibleModal: CONS.MODAL_WEBHOOK_DOC,
        }));
    };
    const removeTodolistIntegration = (appId) => {
        dispatch(todoListActions.removeTodolistIntegration(appId));
    };
    // Local state (from original ConfigModal)
    const [pomodoroMin, setPomodoroMin] = useState(configObj.stageSeconds[0] / 60);
    const [shortBreakMin, setShortBreakMin] = useState(configObj.stageSeconds[1] / 60);
    const [longBreakMin, setLongBreakMin] = useState(configObj.stageSeconds[2] / 60);
    // const [tickingOn, setTickingOn] = useState(false);
    // const [modalVisible, setModalVisible] = useState(false);
    // const [webPushSubscription] = useWebPushEnabled(webpushSubs.length);
    function canSubmit() {
        return (pomodoroMin >= 0.1 &&
            shortBreakMin >= 0 &&
            longBreakMin >= 0 &&
            configObj.longBreakInterval > 0);
    }
    function handleCloseModal() {
        // Save all the configuration to IndexDB
        // when the user close the config modal
        if (canSubmit()) {
            const newStageSeconds = [
                pomodoroMin * 60,
                shortBreakMin * 60,
                longBreakMin * 60,
            ];
            updateConfigObj({
                ...configObj,
                stageSeconds: newStageSeconds,
            });
            // changeStageSeconds(newStageSeconds);
            if (authenticated) {
                saveConfigToMongoDB({
                    ...configObj,
                    stageSeconds: newStageSeconds,
                });
            }
            else {
                saveConfigToLocalDB({
                    ...configObj,
                    stageSeconds: newStageSeconds,
                });
            }
            closeModal();
        }
    }
    function handleSwitchAutoStart() {
        updateConfigObj({
            ...configObj,
            autoStartEnabled: !configObj.autoStartEnabled,
        });
    }
    function handleSwitchAutoStartPomodoro() {
        updateConfigObj({
            ...configObj,
            autoStartPomodoroEnabled: !configObj.autoStartPomodoroEnabled,
        });
    }
    function handleSwitchAutoSwitchTasks() {
        updateConfigObj({
            ...configObj,
            autoSwitchTasks: !configObj.autoSwitchTasks,
        });
    }
    function handleSwitchAutoCheckTasks() {
        updateConfigObj({
            ...configObj,
            autoCheckTasks: !configObj.autoCheckTasks,
        });
    }
    function handleChangeLongBreakInterval(pomodoros) {
        // changeLongBreakInterval(pomodoros);
        updateConfigObj({
            ...configObj,
            longBreakInterval: pomodoros,
        });
    }
    function handleSelectNotificationType(_notificationType) {
        updateConfigObj({
            ...configObj,
            notificationType: _notificationType,
        });
    }
    function tryTickingSound(_tickingSoundType) {
        if (!sounds.isTicking()) {
            sounds.startSoundTicking(_tickingSoundType, true);
        }
    }
    function handleSelectTickingSoundType(_tickingSoundType) {
        updateConfigObj({
            ...configObj,
            tickingSoundType: _tickingSoundType,
        });
        tryTickingSound(_tickingSoundType);
    }
    function _handleChangeTickingVolume(e) {
        updateConfigObj({
            ...configObj,
            tickingVolume: Number(e.target.value),
        });
        sounds.changeTickingVolume(Number(e.target.value));
    }
    function onReleaseTickingVolume() {
        sounds.startSoundTicking(configObj.tickingSoundType, true);
    }
    function _handleChangeAlarmSoundType(_alarmSoundType) {
        if (!_alarmSoundType)
            return;
        updateConfigObj({
            ...configObj,
            alarmSoundType: _alarmSoundType,
        });
        sounds.playSoundBeep(_alarmSoundType, 1);
    }
    function _handleChangeAlarmVolume(e) {
        updateConfigObj({
            ...configObj,
            soundVolume: Number(e.target.value),
        });
        sounds.playSoundBeep(configObj.alarmSoundType, 1);
    }
    function _handleChangeNotificationMinutes(_notificationMinutes) {
        updateConfigObj({
            ...configObj,
            notificationMinutes: _notificationMinutes,
        });
    }
    function _handleChangeAlarmRepeatTimes(_alarmRepeatTimes) {
        if (!_alarmRepeatTimes)
            return;
        updateConfigObj({
            ...configObj,
            alarmRepeatTimes: _alarmRepeatTimes,
        });
    }
    const onClickCrossDeviceInfo = () => {
        showCrossDeviceAlarmDocModal();
    };
    const onClickAutoSwitchTasks = () => {
        window.alert('If you enable "Auto Switch Tasks", the checked task will be automatically moved to the bottom of the task list.');
    };
    const onClickAutoCheckTasks = () => {
        window.alert('If you enable "Auto Check Tasks", the active task will be automatically checked when the actual pomodoro count reaches the estimated count.');
    };
    const onClickAddWebpush = async () => {
        if (!authenticated) {
            window.alert('Please log in to use this feature.');
            return;
        }
        const webPushSubscription = await getCurrentPushSubscription();
        if (webPushSubscription &&
            webpushSubs.some((sub) => sub.auth ===
                JSON.parse(JSON.stringify(webPushSubscription)).keys.auth)) {
            window.alert('This device has already been added.');
            return;
        }
        try {
            // Service worker is automatically initialized when needed
            const subscription = await subscribeToPush(ENV.VAPID_PUBLIC_KEY);
            const subscriptionStr = JSON.stringify(subscription);
            addWebPushSub(subscriptionStr, WEBPUSH_TYPE_BOTH);
        }
        catch (err) {
            console.error('Failed to subscribe to push notifications:', err);
            window.alert('Please add Pomofocus to your home screen first.');
        }
    };
    const handleClickWebPushTest = () => {
        testWebPush();
    };
    useEffect(() => {
        setPomodoroMin(configObj.stageSeconds[0] / 60);
        setShortBreakMin(configObj.stageSeconds[1] / 60);
        setLongBreakMin(configObj.stageSeconds[2] / 60);
    }, [configObj.stageSeconds]);
    useEffect(() => {
        sounds.changeSoundVolume(configObj.soundVolume);
    }, [configObj.soundVolume]);
    useEffect(() => {
        sounds.changeTickingVolume(configObj.tickingVolume);
    }, [configObj.tickingVolume]);
    return (React.createElement(Modal, { closeModal: handleCloseModal, modalVisible: configModalVisible, maxWidth: 400 },
        React.createElement(Title, null, "Setting"),
        React.createElement(ModalUpper, null,
            React.createElement(SettingForm, null,
                React.createElement(TimerConfig, { pomodoroMin: pomodoroMin, shortBreakMin: shortBreakMin, longBreakMin: longBreakMin, onChangePomodoroMin: setPomodoroMin, onChangeShortBreakMin: setShortBreakMin, onChangeLongBreakMin: setLongBreakMin, handleSwitchAutoStart: handleSwitchAutoStart, handleSwitchAutoStartPomodoro: handleSwitchAutoStartPomodoro, handleChangeLongBreakInterval: handleChangeLongBreakInterval }),
                React.createElement(DividerDiv, null),
                React.createElement(TaskConfig, { onClickAutoCheckTasks: onClickAutoCheckTasks, onClickAutoSwitchTasks: onClickAutoSwitchTasks, handleSwitchAutoCheckTasks: handleSwitchAutoCheckTasks, handleSwitchAutoSwitchTasks: handleSwitchAutoSwitchTasks }),
                React.createElement(DividerDiv, null),
                React.createElement(SoundConfig, { onChangeAlarmSoundType: _handleChangeAlarmSoundType, onChangeAlarmVolume: _handleChangeAlarmVolume, onChangeAlarmRepeatTimes: _handleChangeAlarmRepeatTimes, onChangeTickingSoundType: handleSelectTickingSoundType, onChangeTickingVolume: _handleChangeTickingVolume, onReleaseTickingVolume: onReleaseTickingVolume, alarmSoundSelection: sounds.ALARM_SOUND_SELECTION, tickingSoundSelection: sounds.TICKING_SOUND_SELECTION }),
                React.createElement(DividerDiv, null),
                React.createElement(ThemeConfig, null),
                React.createElement(DividerDiv, null),
                React.createElement(NotificationConfig, { handleSelectNotificationType: handleSelectNotificationType, handleChangeNotificationMinutes: _handleChangeNotificationMinutes, onClickCrossDeviceInfo: onClickCrossDeviceInfo, onClickAddWebpush: onClickAddWebpush, handleClickWebPushTest: handleClickWebPushTest, webpushSubs: webpushSubs, updateWebPushSub: updateWebPushSub, removeWebPushSub: removeWebPushSub }),
                React.createElement(DividerDiv, null),
                React.createElement(ReportConfig, null),
                React.createElement(DividerDiv, null),
                React.createElement(IntegrationConfig, { userId: userId, todolistAppId: todolistAppId, isPremium: isPremium, showUpgradeModal: showUpgradeModal, removeTodolistIntegration: removeTodolistIntegration, showTodoistDocModal: showTodoistDocModal, showWebhookDocModal: showWebhookDocModal, openWebhookModal: openWebhookModal }))),
        React.createElement(ModalLower, null,
            React.createElement(Button, { theme: "primary", size: "medium", onClick: handleCloseModal, disabled: !canSubmit() }, "OK"))));
}
export default ConfigModal;
const Title = styled.div `
  ${ModalTitle}
`;
const ModalUpper = styled.div `
  padding: 0px 20px 0px 20px;
`;
const ModalLower = styled.div `
  ${ModalFooterStyle}
  display: flex;
  justify-content: flex-end;
`;
const SettingForm = styled.div ``;
export const SectionWrapper = styled.div `
  /* border-bottom: 1px solid ${colors.BG_GRAY}; */
  /* border-bottom: 1px solid #dfdfdf; */
  padding-bottom: 12px;
  margin-bottom: 12px;
`;
export const DividerDiv = styled.div `
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
`;
export const SubHeader = styled.div `
  font-size: 14px;
  color: ${colors.FONT_THIRD};
  font-weight: bold;
  /* margin-bottom: 18px; */
  text-transform: uppercase;
  letter-spacing: 0.8px;
  /* color: ${colors.THEME_COLOR_7}; */

  margin-top: 28px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;
export const SubHeaderIcon = styled.img `
  width: 16px;
  opacity: 0.3;
  margin-right: 6px;
`;
